import React from "react";
import { Link } from "react-router-dom";

export default ({ to, className, children, id }) => (
  <Link {...{ to, id, className }}>{children}</Link>
);
